import uri from 'urijs';

export const isFullUrl = location => {
  const url = uri(location);
  return url.protocol() && url.hostname();
};



// WEBPACK FOOTER //
// ./app/services/is-full-url.js